

export const countrysData = [
  { label: 'Argentina', value: 'AR' },
  { label: 'Belice', value: 'BZ' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Brasil', value: 'BR' },
  { label: 'Chile', value: 'CL' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Haití', value: 'HT' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'México', value: 'MX' },
  { label: 'Nicaragua', value: 'NI' },
  { label: 'Panamá', value: 'PA' },
  { label: 'Paraguay', value: 'PY' },
  { label: 'Perú', value: 'PE' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'República Dominicana', value: 'DO' },
  { label: 'Surinam', value: 'SR' },
  { label: 'Uruguay', value: 'UY' },
  { label: 'Venezuela', value: 'VE' }
];